export default "__VITE_ASSET__5sgDY2Jr__"